module.exports = __webpack_public_path__ + "img/tong.476aa850.png";